<div class="menuItem sidebar" (click)="redirectTo('buManagement')" [ngClass]="{'active': selectedTab === activeTab.BusinessUnits}">
  <div class="sidebar-icon-container">
    <svg-icon class="menu-navigation-icon" title="{{'settingsDialog.businessUnitSettings' | translate | uppercase}}"
              src='./assets/icons/bunsinessUnits.svg' align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.businessUnitSettings' | translate | uppercase}}</div>
</div>
<div class="menuItem sidebar" (click)="redirectTo('userManagement')" [ngClass]="{'active': selectedTab === activeTab.Users}">
  <div class="sidebar-icon-container">
    <svg-icon src='./assets/icons/users.svg'
              title="{{'settingsDialog.userSettings' | translate | uppercase}}"
              class="menu-navigation-icon" align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.userSettings' | translate | uppercase}}</div>
</div>
<div class="menuItem sidebar" (click)="redirectTo('managementroleManagement')" [ngClass]="{'active': selectedTab === activeTab.RoleManagment}">
  <div class="sidebar-icon-container">
    <svg-icon src='./assets/icons/rolesManagement.svg'
              title="{{'settingsDialog.managementRoles' | translate | uppercase}}"
              class="menu-navigation-icon" align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.managementRoles' | translate | uppercase}}</div>
</div>
<div class="menuItem sidebar" (click)="redirectTo('calcModels')" [ngClass]="{'active': selectedTab === activeTab.CalculationModel}">
  <div class="sidebar-icon-container">
    <svg-icon src='./assets/icons/library-outline.svg'
              title="{{'settingsDialog.calcModels' | translate | uppercase}}"
              class="menu-navigation-icon" align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.calcModels' | translate | uppercase}}</div>
</div>
<div class="menuItem sidebar" (click)="redirectTo('raciTemplate')" [ngClass]="{'active': selectedTab === activeTab.RaciTemplate}" *ngIf="showProcessTemplateSettings">
  <div class="sidebar-icon-container">
    <svg-icon src='./assets/icons/footsteps-outline.svg'
              title="{{'settingsDialog.raciTemplate' | translate | uppercase}}"
              class="menu-navigation-icon" align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.raciTemplate' | translate | uppercase}}</div>
</div>
<div class="menuItem sidebar" (click)="redirectTo('localizationHost')" [ngClass]="{'active': selectedTab === activeTab.LocalizationHost}">
  <div class="sidebar-icon-container">
    <svg-icon src='./assets/icons/dictionary-outline.svg'
              title="{{'settingsDialog.localization' | translate | uppercase}}"
              class="menu-navigation-icon" align='center'></svg-icon>
  </div>
  <div class="menu-navigation-title">{{'settingsDialog.localization' | translate | uppercase}}</div>
</div>
